import { render, staticRenderFns } from "./platTicketInfo.vue?vue&type=template&id=fc4f855c&scoped=true&"
import script from "./platTicketInfo.vue?vue&type=script&lang=js&"
export * from "./platTicketInfo.vue?vue&type=script&lang=js&"
import style0 from "./platTicketInfo.vue?vue&type=style&index=0&id=fc4f855c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4f855c",
  null
  
)

export default component.exports